export const NatureMethodLogo = () => {
  return <img src="/assets/img/logos/NatureLogo.svg" alt="Nature Journal" width="238" height="28" />
}
